import { answerApi } from './apis';
import { convertToQueryString } from '@utils';
import {
  AnswerEntityInterface,
  AnswerQueryInterface,
  CreateAnswerRequestInterface,
  CreatedAnswerResponseInterface,
  DeleteAnswersRequestInterface,
  GenericItemsResponseInterface,
  PatchAnswersAsSentRequestInterface,
  UpdateAnswerRequestInterface,
} from '@types';

const ROUTES = {
  createAnswer: '/',
  getAllAnswers: '/',
  getUserAnswerId: '/user-answer',
  markAnswersAsSent: '/sent-answers',
  deleteAnswers: '/delete-answers',
  getAnswerById: '/',
  updateAnswer: '/',
};

export const getAnswerById = async (id: string): Promise<AnswerEntityInterface> => {
  const response = await answerApi.get(ROUTES.getAnswerById + id);
  return response.data;
};

export const getAllAnswers = async (
  query: AnswerQueryInterface
): Promise<GenericItemsResponseInterface<AnswerEntityInterface>> => {
  const response = await answerApi.get(ROUTES.getAllAnswers + convertToQueryString(query));
  return response.data;
};

export const createAnswer = async (
  data: CreateAnswerRequestInterface
): Promise<CreatedAnswerResponseInterface> => {
  const response = await answerApi.post(ROUTES.createAnswer, data);
  return response.data;
};

export const updateAnswer = async (
  id: string,
  data: UpdateAnswerRequestInterface
): Promise<void> => {
  const response = await answerApi.put(ROUTES.updateAnswer + id, data);

  return response.data;
};

export const deleteAnswers = async (data: DeleteAnswersRequestInterface): Promise<void> => {
  const response = await answerApi.post(ROUTES.deleteAnswers, data);
  return response.data;
};

export const markAnswersAsSent = async (
  data: PatchAnswersAsSentRequestInterface
): Promise<void> => {
  const response = await answerApi.patch(ROUTES.markAnswersAsSent, data);

  return response.data;
};
